import axiosClient from "./axiosClient";



export const checkAuth = async () => {
    try {
        // 1. 서버의 /auth/check 엔드포인트 호출
        // axiosClient에 withCredentials: true 설정이 되어 있어야 쿠키가 전송됩니다.
        const response = await axiosClient.get('/auth/check');
        

        return response.data;
    } catch (error) {
        // 3. 실패 시 (401 Unauthorized 등) 에러를 로깅하고 throw

        
        // 에러를 던져서 호출하는 곳(AuthContext 등)에서 setUser(null) 처리를 하게 합니다.
        throw error;
    }
};



export const loginWithKakao = async (code) => {
    try {
        const response = await axiosClient.post(
            "/auth/kakao", // axiosClient에 baseURL이 설정되어 있다면 상대 경로만 사용
            { code },
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};



export const loginWithGoogle = async (code) => {
    try {
        const response = await axiosClient.post(
            "/auth/google",
            { code },
            {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};


export const loginWithEmail = async ({ email, password }) => {
    const response = await axiosClient.post('/auth/login', { email, password });
    return response.data;
};

export const registerWithEmail = async ({ email, password }) => {
    const response = await axiosClient.post('/auth/register', { email, password });
    return response.data;
};

export const getAccountInfo = async () => {
    const response = await axiosClient.get('/accounts/me');
    return response.data;
};

export const updateUserPhone = async (phone) => {
    const response = await axiosClient.patch('/accounts/me', { phone_number: phone });
    return response.data;
};

export const updateUserPassword = async ({ current_password, new_password }) => {
    const response = await axiosClient.patch('/accounts/me/password', { current_password, new_password });
    return response.data;
};

export const logout = async () => {
    try {
        const response = await axiosClient.post('/auth/logout', {

        }, {
            // 서버에서 쿠키를 읽고(access_token) 삭제 명령을 내릴 수 있도록 설정
            withCredentials: true 
        });
        
        return response.data;
    } catch (error) {
        throw error;
    }
};